var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical_video_warp"},[_c('HeadBar'),_c('div',{attrs:{"id":"video"}},[_c('div',{staticClass:"avoid_sliding",on:{"click":_vm.pause}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }